import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Container from '@material-ui/core/Container';
import Tab from '@material-ui/core/Tab';

import Tabs from 'components/CustomTabs/CustomTabs';

import PersonalData from 'pages/Accounts/Edit/Contract/PersonalData/PersonalData';
import AML from 'pages/Accounts/Edit/Contract/AML/AML';
import AdditionalInfo from 'pages/Accounts/Edit/Contract/AdditionalInfo/AdditionalInfo';
import ContractDocuments from 'pages/Accounts/Edit/Contract/ContractDocuments/ContractDocuments';
import { APP_CONFIG } from 'appConfig';

export enum ContractTab {
  PERSONAL_DATA = 0,
  ADDITIONAL_INFO = 2,
  DOCS = 3,
  AML = 1,
}

const Contract: React.FC = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState<ContractTab>(ContractTab.PERSONAL_DATA);

  // value?: number should be value: number, but the @material-ui typing is bugged
  const handleTabChange = (_event: React.ChangeEvent<{}>, newTab?: ContractTab) => {
    if (newTab !== undefined && (newTab < tab || APP_CONFIG.uiSwitchTabs)) {
      setTab(newTab);
    }
  };

  return (
    <Container maxWidth="md">
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab value={ContractTab.PERSONAL_DATA} label={t('contract_personalData')} />
          <Tab value={ContractTab.AML} label={t('contract_aml')} disabled={!APP_CONFIG.uiSwitchTabs && tab < 1} />
          <Tab
            value={ContractTab.ADDITIONAL_INFO}
            label={t('contract_additionalInfo')}
            disabled={!APP_CONFIG.uiSwitchTabs && tab < 2}
          />
          <Tab value={ContractTab.DOCS} label={t('contract_docs')} disabled={!APP_CONFIG.uiSwitchTabs && tab < 3} />
        </Tabs>

        {tab === ContractTab.PERSONAL_DATA && <PersonalData tabChange={setTab} />}
        {tab === ContractTab.AML && <AML tabChange={setTab} />}
        {tab === ContractTab.ADDITIONAL_INFO && <AdditionalInfo tabChange={setTab} />}
        {tab === ContractTab.DOCS && <ContractDocuments tabChange={setTab} />}
    </Container>
  );
};

export default Contract;
